<template>
  <div>
    <form ref="form" action="" @submit.prevent="save">
      <div class="row m-0">
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Title поставщика</label>
            <input type="text" required v-model="localSupplier.title" placeholder="Title" class="form-control">
            <p class="text-muted small_info">короткое отображение в заказе препаратов</p>
          </div>
          <div class="form-group">
            <label for="">Login url</label>
            <input type="text" v-model="localSupplier.url" placeholder="Login url" class="form-control">
            <p class="text-muted small_info">ссылка для авторизации</p>
          </div>
          <div class="form-group">
            <label for="">Посковый запрос</label>
            <input type="text" v-model="localSupplier.search_url" placeholder="Search url"
                   class="form-control">
            <p class="text-muted small_info">поисковый запрос $$$PZN$$$ для pzn</p>
          </div>
          <div class="form-group">
            <label for="">POST поле для поиска</label>
            <input type="text" v-model="localSupplier.search_post.post_fields.pzn" placeholder="POST field"
                   class="form-control">
            <p class="text-muted small_info">если поисковый запрос POST, то каким полем передавать PZN</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Страна</label>
            <select required v-model="localSupplier.country_id" class="form-control">
              <option value="" disabled>Выберите страну</option>
              <option v-for="country in $AllCountries" :value="country.id">{{ country.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Login</label>
            <input type="text" v-model="localSupplier.login" placeholder="Login" class="form-control">
          </div>
          <div class="form-group">
            <label for="">Password</label>
            <input type="text" v-model="localSupplier.password" placeholder="Password" class="form-control">
          </div>
          <div class="form-group">
            <label for="">Максимальное количесво упаковок</label>
            <input required type="number" v-model="localSupplier.max_qty" placeholder="Максимум на препарат"
                   class="form-control">
          </div>
          <div class="form-group">
            <label for="">Скидка в % от суммы заказа</label>
            <input required type="number" v-model="localSupplier.options.discount" placeholder="Скидка на заказ"
                   class="form-control">
          </div>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="ch_2" v-model="localSupplier.use_default">
            <label class="form-check-label" for="ch_2">Использовать по умолчанию для страны</label>
          </div>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="ch_1" v-model="localSupplier.options.useBasket">
            <label class="form-check-label" for="ch_1">Использовать корзину для заказа</label>
          </div>
          <button class="hidden" type="submit">submit</button>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Склад перемещения по умолчанию</label>
            <select v-model="localSupplier.options.default_store_id" class="form-control">
              <option value="0" disabled>Выберите склад</option>
              <option v-for="s in Object.values($AllStores).filter((s) => s.is_active && s.id !== 1)" :value="s.id">
                {{ s.title }}
              </option>
            </select>
            <!--            <multiselect-->
            <!--              class="mr-1"-->
            <!--              v-model="selected_projects"-->
            <!--              :options="allProjects"-->
            <!--              :multiple="true"-->
            <!--              label="name"-->
            <!--              track-by="name"-->
            <!--              placeholder="Выберите проект"-->
            <!--              select-label="Выбрать"-->
            <!--              deselect-label="Убрать проект">-->
            <!--            </multiselect>-->
          </div>
          <div class="form-group">
            <label>Настройка расходов на доставку</label>
            <button class="btn btn-xs btn-default" type="button" @click="addDeliveryExpenses">добавить просчет</button>
            <div v-for="(e,i) in localSupplier.options.delivery_expenses" class="input-group" :key="i">
              <select v-model="e.type" class="form-control">
                <option value="0" disabled>Выберите тип</option>
                <option v-for="t in $platformConstants.supplierDeliveryExpensesTypes"
                        :value="t.alias">{{ t.title }}
                </option>
              </select>
              <input type="text" v-if="['byVolume', 'byWeight'].includes(e.type)" placeholder="Количество"
                     v-model="e.unit" class="form-control">
              <input type="text" placeholder="Сумма" v-model="e.amount" class="form-control">
              <select v-model="e.currency_id" class="form-control">
                <option value="0" disabled>Выберите валюту</option>
                <option v-for="c in $AllCurrencies" :value="c.id">{{ c.currency }}</option>
              </select>
              <div class="input-group-append">
                <button type="button" @click="removeExpenses(i)" class="btn btn-outline-danger">
                  <i class="icon-fa icon-fa-trash"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-2"/>
    </form>
  </div>
</template>

<script>

import api from "@/api";
import Multiselect from 'vue-multiselect'

export default {
  props: ['supplier', 'onSave'],
  components: {
    Multiselect,
  },
  data() {
    return {
      loading: false,
      localSupplier: {},
      deliveryExpensesTypes: [
        {title: 'По объему', alias: 'byVolume'},
        {title: 'По весу', alias: 'byWeight'},
        {title: 'По упаковкам', alias: 'byItem'},
        {title: '% от стоимости', alias: 'percentByPrice'},
      ],
    }
  },
  created() {
    this.initSupplier();
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  methods: {
    removeExpenses(index) {
      delete this.localSupplier.options.delivery_expenses[index];
      this.localSupplier.options.delivery_expenses = this.localSupplier.options.delivery_expenses.filter((e) => e);
    },
    addDeliveryExpenses() {
      if (!this.localSupplier.options.delivery_expenses) this.$set(this.localSupplier.options, 'delivery_expenses', []);
      this.localSupplier.options.delivery_expenses.push({type: 0, unit: null, amount: null, currency_id: 0})
    },
    initSupplier() {
      this.localSupplier = {...this.supplier};
      if (!this.localSupplier.search_post) {
        this.localSupplier.search_post = {post_fields: {pzn: null}};
      }
      if (!this.localSupplier.options) {
        this.localSupplier.options = {
          useBasket: false,
          discount: null,
          default_store_id: 0,
          delivery_expenses: [],
        };
      }
    },
    async save(e) {
      if (this.loading) return;
      if (!e) {
        this.$refs.form.querySelector('button[type="submit"]').click();
        return;
      }
      this.loading = true;
      const {data} = await api.post('/new/suppliers', {
        action: 'update',
        supplier: this.localSupplier
      })
      if (data.success) {
        toastr['success']('Сохранено')
        if (this.onSave) {
          this.onSave();
        }
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.small_info {
  font-size: 14px;
}
</style>
